import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  return jsx("div", {
    sel: '.mp-button-bar-container',
    class: Object.assign(this.helpers.getComponentClasses("mp-button-bar-"), {
      ["mp-button-bar-".concat(this.attr("color"))]: true,
      'is-disabled': this.attr("disabled")
    }),
    attrs: {
      elref: "buttonBarContainer"
    }
  }, jsx("div", {
    sel: '.mp-button-bar-content-wrapper'
  }, jsx("div", {
    sel: '.mp-button-bar-content'
  }, jsx("slot", null)), this.attr("arrow-next") ? jsx("div", {
    sel: '.mp-button-bar-arrow-next'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "arrow-right"
    }
  })) : null));
}